import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Portfolio from "./pages/Portfolio";
import Estimate from "./pages/Estimate";
import Customizations from "./components/Customizations";
import ScrollToTop from "./components/ScrollToTop";
import NotFound from "./components/NotFound";



function App() {
  return (
    <Router>
      <ScrollToTop />   {/* ← add this */}

      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/estimate" element={<Estimate />} />
        <Route path="/customizations" element={<Customizations />} />

        {/* Products List Page */}
        <Route path="/products" element={<Products />} />

        {/* Dynamic Product Page */}
        <Route path="/products/:slug" element={<ProductDetails />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App